// ==========================================================================
// CACTUS KNIGHT — Produkt-Sprungmarken (Details / Beschreibung / Spezifikationen)
// Details, Beschreibung und Spezifikationen stehen permanent untereinander.
// Die Buttons oben scrollen sanft zum jeweiligen Bereich, statt Inhalte
// ein-/auszublenden. Während des Scrollens wird automatisch markiert, in
// welchem Bereich man sich gerade befindet (Scroll-Spy).
// ==========================================================================

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".product-tabs__btn");
  // [data-tab-panel] statt .product-tabs__panel, damit auch die
  // "Spezifikationen"-Überschrift (die innerhalb von Beschreibung liegt,
  // aber ihre eigene Sprungmarke hat) vom Scroll-Spy erkannt wird.
  const panels = document.querySelectorAll("[data-tab-panel]");
  if (buttons.length === 0 || panels.length === 0) return;

  function setActive(target) {
    buttons.forEach((b) => b.classList.toggle("is-active", b.dataset.tab === target));
  }

  // ---- Klick: sofort markieren + sanft zum Bereich scrollen ----
  // Vorher wurde nur gescrollt und auf den Scroll-Spy gewartet. Da der
  // Abschnitt nach dem Scrollen aber ein paar Pixel UNTERHALB der Messlinie
  // landete, blieb der vorherige Tab markiert, bis man nochmal weiterscrollte.
  // Jetzt wird (a) sofort markiert, (b) der Spy für die Dauer der Animation
  // ausgesetzt und (c) mit berechnetem Offset gescrollt, sodass der Abschnitt
  // exakt an der Messlinie zu liegen kommt.
  let suppressSpyUntil = 0;

  function scrollToPanel(panel) {
    const topbarH =
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--topbar-height")) || 0;
    const navH = nav ? nav.getBoundingClientRect().height : 0;
    // Ziel: Oberkante des Abschnitts knapp oberhalb der Messlinie
    const targetY = window.scrollY + panel.getBoundingClientRect().top - (topbarH + navH) - 2;
    window.scrollTo({ top: Math.max(0, targetY), behavior: "smooth" });
  }

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const panel = document.getElementById(`section-${btn.dataset.tab}`);
      if (!panel) return;
      setActive(btn.dataset.tab);
      suppressSpyUntil = Date.now() + 900;
      scrollToPanel(panel);
    });
  });

  // ---- Scroll-Spy: aktiven Button je nach Scroll-Position markieren ----
  // Hinweis: Bewusst KEIN IntersectionObserver mit schmaler rootMargin-Zone,
  // da kurze Abschnitte (z. B. "Spezifikationen") dabei übersprungen werden
  // können, wenn der Nutzer schnell scrollt. Stattdessen wird bei jedem
  // Scroll-Event geprüft, welcher Abschnitt zuletzt die Nav-Unterkante
  // passiert hat — das erkennt jeden Abschnitt zuverlässig, unabhängig
  // von seiner Höhe.
  const nav = document.querySelector(".product-tabs__nav");
  let scrollSpyTicking = false;

  function updateActiveByScroll() {
    scrollSpyTicking = false;
    if (!nav) return;
    // Während des Klick-Scrollens nicht dazwischenfunken
    if (Date.now() < suppressSpyUntil) return;

    // Kleines Toleranzband: gleicht Rundungen und den Höhenwechsel des
    // Headers (Kompakt-Modus) aus, damit kurz vor dem exakten Erreichen
    // eines Abschnitts nicht noch der vorherige markiert bleibt.
    const TOLERANCE = 12;
    const refY = nav.getBoundingClientRect().bottom + 4;
    let current = panels[0];
    panels.forEach((panel) => {
      if (panel.getBoundingClientRect().top - refY <= TOLERANCE) {
        current = panel;
      }
    });
    const target = current.dataset.tabPanel;
    if (target) setActive(target);
  }

  window.addEventListener(
    "scroll",
    () => {
      if (!scrollSpyTicking) {
        scrollSpyTicking = true;
        requestAnimationFrame(updateActiveByScroll);
      }
    },
    { passive: true }
  );

  updateActiveByScroll();

  // ---- Sterne-Bewertung oben in der Sidebar: springt zum Bewertungen-Tab ----
  const ratingLink = document.getElementById("product-rating-link");
  if (ratingLink) {
    ratingLink.addEventListener("click", () => {
      const bewertungenBtn = document.querySelector('.product-tabs__btn[data-tab="bewertungen"]');
      if (bewertungenBtn) bewertungenBtn.click();
    });
  }
});
